import { render, staticRenderFns } from "./Terms&Conditions.vue?vue&type=template&id=2aea7261&scoped=true&"
var script = {}
import style0 from "./Terms&Conditions.vue?vue&type=style&index=0&id=2aea7261&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aea7261",
  null
  
)

export default component.exports